// This is the predefined endpoint ID for the on/off cluster.
export const MATTER_ON_OFF_ENDPOINT_ID = 1;
export const MATTER_OPEN_COMMISSIONING_WINDOW_DURATION_SECONDS = 250;
